import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";

const truncateValue = (value, maxLength) => {
  if (value.length > maxLength) {
    return value.substring(0, maxLength) + "...";
  }
  return value;
};

const OrderInfoSection = ({
  title,
  value,
  trucateVal = false,
  maxLength = 20,
}) => {
  const [adjustedMaxLength, setAdjustedMaxLength] = useState(maxLength);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 360) {
        setAdjustedMaxLength(12);
      } else if (width < 600) {
        setAdjustedMaxLength(18);
      } else {
        setAdjustedMaxLength(22);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Box
      component="div"
      sx={{ display: "flex", alignItems: "center", gap: "2px", mb: 0.5 }}
    >
      <Typography fontSize={14}>{title} :</Typography>
      <Typography fontSize={15} ml={"2px"} fontWeight={500}>
        {trucateVal ? truncateValue(value, adjustedMaxLength) : value}
      </Typography>
    </Box>
  );
};

export default OrderInfoSection;
